<template>
  <b-modal
    id="modal-edit-avatar"
    cancel-variant="outline-secondary"
    centered
    size="md"
    title="上傳頭像"
    :ok-disabled="false"
    hide-footer
    @hide="resetModal"
  >
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form class="" @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <!-- <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_sort_order"
                > 
                <b-form-group
                      label="排序："
                      label-for="sort_order"
                      label-cols-md="3"
                      class="require"
                    >
                  <b-form-input
                    v-model="newAvatarData.sort_order"
                    class="d-inline-block"
                    placeholder="排序"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
            </b-col> -->
            <b-col cols="12">
              <b>為了最優顯示，請上傳200px*200px的圖片</b>
                <b-form-group
                  label="頭像"
                  label-for="image"
                  label-cols-md="3"
                  class="required mt-2"
                >
                  <el-upload
                    class="avatar-uploader"
                    list-type="picture-card"
                    ref="upload"
                    :action="uploadUrl"
                    :headers="headerObj"
                    name="file"
                    :file-list="fileList"
                    multiple
                    :limit="1"
                    :data="newAvatarData"
                    :on-change="onChange"
                    :on-remove="toggleUpload"
                    :before-remove="beforeRemove"
                    :auto-upload="false"
                    :class="{ hideUpload: !showUpload }"
                  >
                    <img
                      class="w-100"
                      v-if="newAvatarData.image_url && showUpload"
                      :src="newAvatarData.image_url"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <label
                    v-if="
                      newAvatarData.id == 0 && !newAvatarData.file
                    "
                    class="error-text"
                  >
                  圖片是必填項</label
                  >
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12">
                <b-form-group
                  label="狀態"
                  label-for="is_active"
                  label-cols-md="2"
                  class="mt-2"
                >
                  <b-form-checkbox
                    :checked="newAvatarData.is_active"
                    name="is_active"
                    switch
                    inline
                    v-model="newAvatarData.is_active"
                    value="1"
                    style="margin-top: 5px"
                  >
                    {{ newAvatarData.is_active ? "啟用" : "禁止" }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col> -->
            <b-col
              cols="12"
              class="d-flex flex-wrap justify-content-center w-100 p-2"
            >
              <b-button
                variant="primary"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1 px-3"
                type="submit"
              >
                提交
              </b-button>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                class="px-3"
                @click="hide"
              >
                取消
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>
  
  <script>
import Ripple from "vue-ripple-directive";
import store from "@/store";
import { ref, watch, onUnmounted, onMounted } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, alphaNum, email } from "@validations";
import { EventBus } from '@/main'

import {
  BModal,
  BButton,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BForm,
  BFormGroup,
  BFormInvalidFeedback,
  BOverlay,
} from "bootstrap-vue";

export default {
  components: {
    BModal,
    BButton,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BFormGroup,
    BFormInvalidFeedback,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      required
    };
  },
  props: {
    avatarData: {},
    isEdit: {},
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-edit-avatar");
    },
    resetModal() {
      this.newAvatarData = {id:0}
      this.$emit("fouceIsEditFalse");
    },
    onSubmit() {
      if (this.newAvatarData.id == 0 && !this.newAvatarData.file) {
        return
      }
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "確定",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;

          let formData = new FormData();
          formData.append('id', this.newAvatarData.id); 

          if (this.newAvatarData.file) {
            if (this.newAvatarData.file.size >= 2097152) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error! Your Image size is larger then 2M",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
              return;
            } else {
              formData.append("file", this.newAvatarData.file);
            }
          }
          store
            .dispatch("app/editAvatar", formData)
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.loading = false;
              this.hide();
              EventBus.$emit('reload-user-avatar');
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.loading = false;
            });
        }
      });
    },
  },
  watch: {},
  setup(props) {
    const loading = ref(false);
    const newAvatarData = ref({id:0,sort_order:0});

    const resetContractData = () => {
      newAvatarData.value = { id: 0,sort_order:0 };
    };
    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetContractData);

      const showUpload = ref(true);
      const fileList = ref([]);
      const uploadUrl = process.env.VUE_APP_UPLOAD_URL;

      const headerObj = {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
      };

      const onChange = (file) => {
        showUpload.value = !showUpload.value;
        newAvatarData.value.file = file.raw;
      };

      const beforeRemove = (file) => {
        newAvatarData.value.file = null;
      };


    const toggleUpload = () => {
      showUpload.value = !showUpload.value;
    };

    watch(
      () => props.avatarData,
      (newVal) => {
        newAvatarData.value = newVal;
      }
    );
    return {
      refFormObserver,
      getValidationState,
      resetForm,
      loading,
      newAvatarData,
      showUpload,
      fileList,
      uploadUrl,
      headerObj,
      onChange,
      beforeRemove,
      toggleUpload,
    };
  },
};
</script>
  
<style lang="scss">

</style>
  